import { Component, OnInit } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { GroupsService } from '../../services/groups.service';
import { LocalService } from '../../services/local.service';
import { SidenavService } from '../../services/sidenav.service';
import { StandingsService } from '../../services/standings.service';

@Component({
  selector: 'app-stats-snipers',
  templateUrl: './stats-snipers.component.html',
  styleUrls: ['./stats-snipers.component.scss'],
  standalone: false,
})
export class StatsSnipersComponent implements OnInit {
  sidenav: MatSidenav;
  loggedUser: any;
  groups: Array<any> = [];
  groupSelected: string = 'general';
  snipers: Array<any> = [];

  constructor(
    private sidenavService: SidenavService,
    private authService: AuthService,
    private groupsService: GroupsService,
    private localService: LocalService,
    private standingsService: StandingsService,
    private router: Router,
  ) {
    this.sidenav = this.sidenavService.getSidenav();
    this.loggedUser = this.authService.getUser();
  }

  async ngOnInit() {
    this.groups = await this.groupsService.getList();
    this.groupSelected =
      (await this.localService.getDataV2<string>('stgrsel')) || 'general';
    await this.loadSnipers();
  }

  toggleMenu() {
    this.sidenavService.toggle();
  }

  goBack() {
    this.router.navigate(['/stats']);
  }

  async selectGroup(groupId: string) {
    this.groupSelected = groupId;
    await this.localService.saveDataV2('stgrsel', this.groupSelected);
    await this.loadSnipers();
  }

  selectUser(userId: string) {
    this.router.navigate([`/home/${userId}`]);
  }

  private async loadSnipers() {
    const standingsGroupId =
      this.groupSelected === 'general' ? undefined : this.groupSelected;
    const response = await this.standingsService.getSnipers(standingsGroupId);

    this.snipers = (response?.snipers || []).map((sniper: any) => ({
      ...sniper,
      user: {
        _id: sniper.userId,
        name: sniper.userName,
        avatar: sniper.avatar,
      },
    }));
  }
}
